import tinymce, { Editor } from 'tinymce';

/**
 * Open a modal dialog to insert Quote, Author and Year
 */
const openBlockqueoteDialog = (editor: Editor) => {
  editor.windowManager.open({
    title: 'Insert Quote',
    body: {
      type: 'panel',
      items: [
        {
          type: 'textarea',
          name: 'quoteText',
          label: 'Quote',
        },
        {
          type: 'input',
          name: 'quoteAuthor',
          label: 'Author',
        },
        {
          type: 'input',
          name: 'quoteYear',
          label: 'Year',
        },
      ],
    },
    buttons: [
      {
        text: 'Insert',
        type: 'submit',
        primary: true,
      },
      {
        text: 'Cancel',
        type: 'cancel',
      },
    ],
    onSubmit(api) {
      const data = api.getData();
      const blockquoteHtml = `
                <blockquote class="bo-quote">
                    <div class="bo-quote__text">
                        <p>${tinymce.html.Entities.encodeAllRaw(data.quoteText)}</p>
                    </div>
                    <footer class="bo-quote__author">${tinymce.html.Entities.encodeAllRaw(data.quoteAuthor)}, ${tinymce.html.Entities.encodeAllRaw(data.quoteYear)}</footer>
                </blockquote>
            `;

      editor.insertContent(blockquoteHtml, { format: 'raw' });
      api.close();
    },
  });
};

/**
 * Add a custom Quote button to the toolbar
 */
export const blockquote = (editor: Editor) => {
  editor.ui.registry.addButton('blockquoteButton', {
    text: 'Quote',
    tooltip: 'Insert quote',
    onAction() {
      openBlockqueoteDialog(editor);
    },
  });
};
